export default __webpack_public_path__ + "static/target_aud-65205868120dfba9d17fcca53fb85d9c.webp";